import React from 'react';
import {
  buttonStylesForProjects,
  defaultCommandBarButtonStyles,
  titleCommandBarButtonStyles,
} from '../../../styles/button-styles';
import ViewWrapperWithCommandBar from '../../Common/Layout/ViewWrapperWithCommandBar';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { DefaultPalette } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../common/routes';
import SystemClient from '../../../system/SystemClient';
import MessageCourier from '../../../lib/MessageCourier';
import { useTranslation } from 'react-i18next';
import { PlanillaPartidoProgramadoList } from './PlanillaPartidoProgramadoList';
import { Usuario } from '../../../system/Usuario/Usuario';
import { PlanillaPartido } from '../../../system/PlanillaPartido/PlanillaPartido';
interface IPlanillaPartidoProgramadoListController {
  system: SystemClient;
  courier: MessageCourier;
  user: Usuario;
  changeBlockUI: (state: boolean) => void;
  setIsPartidoOnline: (p: boolean) => void;
  setPlanillaPartido: (p: PlanillaPartido | undefined) => void;
}

const PlanillaPartidoProgramadoListController = ({
  system,
  courier,
  changeBlockUI,
  user,
  setIsPartidoOnline,
  setPlanillaPartido,
}: IPlanillaPartidoProgramadoListController) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const itemsMenu = React.useMemo((): ICommandBarItemProps[] => {
    let ret: ICommandBarItemProps[] = [];
    ret.push({
      key: 'title',
      text: t('Partidos programados'),
      iconProps: {
        iconName: 'AccountActivity',
        color: DefaultPalette.themeLighterAlt,
      },
      onClick: () => {},
    });
    return ret;
  }, []);
  return (
    <ViewWrapperWithCommandBar
      withBorderBottom
      title={''}
      items={itemsMenu}
      overflowButtonStyles={defaultCommandBarButtonStyles}
      variant="highlight"
      titleBody="PlanillaPartidoProgramado"
    >
      <PlanillaPartidoProgramadoList
        system={system}
        courier={courier}
        user={user}
        changeBlockUI={changeBlockUI}
        setIsPartidoOnline={(p: boolean) => setIsPartidoOnline(p)}
        setPlanillaPartido={(p: PlanillaPartido | undefined) => setPlanillaPartido(p)}
      />
    </ViewWrapperWithCommandBar>
  );
};

export default PlanillaPartidoProgramadoListController;
